<template>
  <svg
    viewBox="0 0 24 25"
    stroke="currentColor"
    :class="customStyle"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0001 4.8894C10.5113 4.90065 9.03936 5.20505 7.66825 5.78522C6.29714 6.36539 5.05375 7.20996 4.00907 8.27071C2.96439 9.33145 2.13889 10.5876 1.57971 11.9674C1.02053 13.3472 0.738624 14.8236 0.750092 16.3124V18.3894C0.750092 18.7872 0.908128 19.1688 1.18943 19.4501C1.47074 19.7314 1.85227 19.8894 2.25009 19.8894H21.7501C22.1479 19.8894 22.5294 19.7314 22.8108 19.4501C23.0921 19.1688 23.2501 18.7872 23.2501 18.3894V16.3094C23.2725 13.3032 22.0998 10.4113 19.99 8.26965C17.8803 6.12802 15.0063 4.91212 12.0001 4.8894Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 19.8894V19.1394C9 18.3438 9.31607 17.5807 9.87868 17.0181C10.4413 16.4555 11.2044 16.1394 12 16.1394C12.7956 16.1394 13.5587 16.4555 14.1213 17.0181C14.6839 17.5807 15 18.3438 15 19.1394V19.8894"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.25 9.39233L12 16.1423"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.875 16.1394C4.66789 16.1394 4.5 15.9715 4.5 15.7644C4.5 15.5573 4.66789 15.3894 4.875 15.3894"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M4.875 16.1394C5.08211 16.1394 5.25 15.9715 5.25 15.7644C5.25 15.5573 5.08211 15.3894 4.875 15.3894"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M6.375 12.3923C6.16789 12.3923 6 12.2244 6 12.0173C6 11.8102 6.16789 11.6423 6.375 11.6423"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M6.375 12.3923C6.58211 12.3923 6.75 12.2244 6.75 12.0173C6.75 11.8102 6.58211 11.6423 6.375 11.6423"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M9.375 9.39233C9.16789 9.39233 9 9.22444 9 9.01733C9 8.81022 9.16789 8.64233 9.375 8.64233"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M9.375 9.39233C9.58211 9.39233 9.75 9.22444 9.75 9.01733C9.75 8.81022 9.58211 8.64233 9.375 8.64233"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M17.625 12.3894C17.4179 12.3894 17.25 12.2215 17.25 12.0144C17.25 11.8073 17.4179 11.6394 17.625 11.6394"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M17.625 12.3894C17.8321 12.3894 18 12.2215 18 12.0144C18 11.8073 17.8321 11.6394 17.625 11.6394"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M19.125 16.1423C18.9179 16.1423 18.75 15.9744 18.75 15.7673C18.75 15.5602 18.9179 15.3923 19.125 15.3923"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M19.125 16.1423C19.3321 16.1423 19.5 15.9744 19.5 15.7673C19.5 15.5602 19.3321 15.3923 19.125 15.3923"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'DashboardIcon',
  props: {
    customStyle: {
      type: String,
      default: 'w-5 h-5',
    },
  },
}
</script>
